/* T47-ADVISOR (2026-06-04 rev 9) — Christina AI Beauty Advisor v2.9
   T53 (2026-07-04) EN i18n layer: CB_LANG + CBT() — PL default, EN via document.lang + T54 locale in /api/chat payload
   T99 (2026-10-13) rev 11 — sessionId z CSPRNG (crypto.getRandomValues), dataLayer dostaje pseudonim sesji;
   formularz kontaktu: nowe teksty, walidacja, obsługa błędów; postEmailRoutine: 403 LEAD_REQUIRED
   -> jednorazowy formularz i ponowienie, jedna wysyłka i jeden formularz naraz na rutynę.
   R7A1 (2026-08-04) rev 10 — wydajność `setupOverlapAvoidance`:
   - usunięty nasłuch `scroll` + `requestAnimationFrame` (310 ms self-time na PDP mobile w trace CDP)
   - kolizja launchera liczona jednym IntersectionObserver-em z `rootMargin` zwężonym do prostokąta launchera
   - PDP: obserwowany główny formularz produktu, kolekcja: przyciski kafli nie są skanowane w ogóle
   - referencje elementów cache'owane, odświeżanie tylko w kontenerze pilnowanym przez wąski MutationObserver
   - `disconnect()` przy otwarciu panelu, zmianie breakpointu, `pagehide` i `ChristinaAdvisor.destroy()`
   - gdy `.cca-launcher` jest ukryty (T59-ENTRY) nie powstaje ani jeden obserwator
   Changes vs rev 8:
   - Mobile touch targets ≥44px (close, segment toggle)
   - Quiz intent label 7 pytań
   - Expandable "Szczegóły produktu" panel z structured fields (INCI/EAN/SPF/contraindications/special_function/etc)
   Changes vs rev 7:
   - SSE text_delta handler — progressive text rendering w bąbelku (TTFT <2s)
   - Bąbelek zawiera placeholder na delta text, na end wymieniany na final reply
   Changes vs rev 6:
   - renderProductCard: FBW carousel "Często kupowane razem" pod tbadges
   - renderRoutine: AM/PM split sections + warning_copy banner (⚠ retinol/AHA/BHA)
   Changes vs rev 5:
   - renderProductCard: hero_blurb subtitle pod tytułem + trust_badges row (SVG icons + labels)
   - tbadges używają icon_svg z metaobject christina_badge (Cruelty-Free, Made in Israel, etc.)
   - blurb renderowany jako italic gray subtitle pod nazwą produktu
   Changes vs rev 4:
   - SSE streaming consumer for /api/chat (stages: thinking, tool_call, tool_result, generating, complete)
   - Per-stage typing label updates ("Sprawdzam Comodex...", "Buduję rekomendację...")
   - Localized stage messages with friendly Polish copy + per-tool variants
   Changes vs rev 3:
   - data-variant-id attribute on .cca-prod for cleaner GTM custom selectors
   - quiz option user-msg uses only label text (without hint subtitle concatenation)
   Changes vs rev 1:
   - postEmailRoutine now checks r.ok and parses upstream error for friendly toast
   - GA4 dataLayer event tracking on all major user actions (open/intent/issue/quiz/add_to_cart/routine_add/email/lead)
   - send Subject -> open, add_to_cart, routine_add, email_routine, lead_capture map to GA4 ecom events too
*/
(function(){
  'use strict';
  var CB_LANG=((document.documentElement&&document.documentElement.lang)||'pl').slice(0,2).toLowerCase();
  var CB_PL_EN={"Online · doradca kosmetologiczno-sprzedażowy":"Online · skincare & product advisor","Pomoc w doborze produktów, nie zastępuje konsultacji kosmetologicznej.":"Product guidance only — not a substitute for a professional skin consultation.","Napisz, np. mam przebarwienia":"Type, e.g. I have pigmentation","Cześć{name}! ✨ <b>Jestem doradcą Christina.</b><br>Pomogę Ci dobrać linię, ułożyć rutynę pielęgnacyjną lub odpowiem na pytania o dostawę i rabat na rytuał. <em>Wybierz, jak zacząć:</em>":"Hi{name}! ✨ <b>I'm your Christina advisor.</b><br>I can help you choose a line, build a skincare routine, or answer questions about delivery and bundle discounts. <em>Choose how to start:</em>","Dodano do koszyka":"Added to cart","Dodano {n} produktów do koszyka":"{n} products added to cart","Nie udało się dodać. Spróbuj jeszcze raz.":"Couldn't add to cart. Please try again.","Brak połączenia. Napisz na info@christinacosmetics.pl":"Connection lost. Email us at info@christinacosmetics.pl","Zbyt wiele wiadomości. Spróbuj za chwilę.":"Too many messages. Please try again in a moment.","Wysłano na {email}":"Sent to {email}","Nie udało się wysłać. Napisz na info@christinacosmetics.pl":"Couldn't send. Email us at info@christinacosmetics.pl","Email jeszcze niedostępny — spróbuj za chwilę.":"Email not available yet — please try again shortly.","Dostępny":"In stock","Ostatnie sztuki":"Last few left","Brak na stanie":"Out of stock","Zobacz":"View","+ Koszyk":"+ Add","Dodaj rutynę do koszyka":"Add routine to cart","📧 Na email":"📧 Email me","Razem":"Total","Jak mogę pomóc?":"How can I help?","Wybierz, co Cię dotyczy:":"Choose what applies to you:","Zamknij":"Close","Wstecz":"Back","Klient":"Customer","Kosmetolog / Pro":"Aesthetician / Pro","Analizuję Twoje pytanie":"Analyzing your question","Generuję rekomendację":"Preparing your recommendation","Sprawdzam ofertę Christina":"Checking the Christina range","Szukam pasujących produktów":"Searching for matching products","Sprawdzam szczegóły produktu":"Checking product details","Przeglądam linię produktów":"Browsing the product line","Sprawdzam dostępność":"Checking availability","Sprawdzam Twoje zamówienia":"Checking your orders","Liczę rabat na rytuał":"Calculating your ritual discount","Zapisuję dane kontaktowe":"Saving your contact details","Dobierz linię dla mnie":"Find my perfect line","Quiz 7 pytań · 90 sek.":"7-question quiz · 90 sec","Mam konkretny problem":"I have a specific concern","Przebarwienia, trądzik, SPF":"Pigmentation, acne, SPF","Szukam prezentu":"Looking for a gift","Bestsellery + zestawy":"Bestsellers + sets","Jestem kosmetologiem":"I'm an aesthetician","Pełna oferta Pro · B2B":"Full Pro range · B2B","Status zamówienia":"Order status","Dostawa, zwroty, faktura":"Delivery, returns, invoicing","Pomóż znaleźć produkt":"Help me find a product","Po nazwie lub składniku":"By name or ingredient","Przebarwienia":"Pigmentation","Trądzik":"Acne","Zmarszczki":"Wrinkles","Wrażliwość":"Sensitivity","Sucha skóra":"Dry skin","Brak blasku":"Dull skin","SPF / słońce":"SPF / sun","Smog · stres":"Pollution · stress","Otwórz Christina AI Advisor":"Open Christina AI Advisor","Dla skóry":"Skin type","Problemy":"Concerns","Działanie":"Action","Funkcja":"Function","Wiek":"Age","Pojemność":"Size","Opakowanie":"Packaging","Przeciwwskazania":"Contraindications","Polecane dla":"Recommended for","Składniki kluczowe":"Key ingredients","Oceny":"Rating"," opinii":" reviews","Ukryj szczegóły":"Hide details","Szczegóły produktu":"Product details","Rutyna":"Routine"," z ":" of ","Mam problem: ":"My concern: ","Chcę kwiz skóry":"I'd like to take the skin quiz","Jestem kosmetologiem, pokaż mi ofertę Pro":"I'm an aesthetician, show me the Pro range","Mam pytanie o moje zamówienie":"I have a question about my order","Napisz w pole poniżej, czego szukasz — nazwa, składnik aktywny lub problem.":"Type below what you're looking for — a name, an active ingredient or a skin concern.","<b>Mogę wysłać Ci tę rutynę na email.</b><br>Zostaw kontakt poniżej:":"<b>I can email you this routine.</b><br>Leave your details below:","Uzupełnij wszystkie pola":"Please fill in all fields","Zapisuję...":"Saving...","\" rows=\"1\" maxlength=\"2000\"></textarea><button class=\"cca-send\" type=\"submit\" aria-label=\"Wyślij\"><svg viewBox=\"0 0 24 24\"><path d=\"M22 2L11 13M22 2l-7 20-4-9-9-4 20-7z\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/></svg></button></form>":"\" rows=\"1\" maxlength=\"2000\"></textarea><button class=\"cca-send\" type=\"submit\" aria-label=\"Send\"><svg viewBox=\"0 0 24 24\"><path d=\"M22 2L11 13M22 2l-7 20-4-9-9-4 20-7z\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/></svg></button></form>","<div class=\"cca-footer\">Wspierane przez Claude · Christina Cosmetics 2026</div>":"<div class=\"cca-footer\">Powered by Claude · Christina Cosmetics 2026</div>","<button type=\"button\" class=\"cca-prod__details-toggle\" aria-expanded=\"false\">Szczegóły produktu</button>":"<button type=\"button\" class=\"cca-prod__details-toggle\" aria-expanded=\"false\">Product details</button>","<div class=\"cca-prod__fbw\"><div class=\"cca-prod__fbw-title\">Często kupowane razem</div><div class=\"cca-prod__fbw-list\">":"<div class=\"cca-prod__fbw\"><div class=\"cca-prod__fbw-title\">Frequently bought together</div><div class=\"cca-prod__fbw-list\">","<div class=\"cca-routine__section cca-routine__section--am\"><div class=\"cca-routine__section-title\">☀️ Poranna rutyna</div>":"<div class=\"cca-routine__section cca-routine__section--am\"><div class=\"cca-routine__section-title\">☀️ Morning routine</div>","<div class=\"cca-routine__section cca-routine__section--pm\"><div class=\"cca-routine__section-title\">🌙 Wieczorna rutyna</div>":"<div class=\"cca-routine__section cca-routine__section--pm\"><div class=\"cca-routine__section-title\">🌙 Evening routine</div>","%\"></div></div><div class=\"cca-quiz__step\">Krok ":"%\"></div></div><div class=\"cca-quiz__step\">Step ","<div class=\"cca-lead__field\"><input class=\"cca-lead__input\" type=\"text\" placeholder=\"Imię\" maxlength=\"50\" value=\"":"<div class=\"cca-lead__field\"><input class=\"cca-lead__input\" type=\"text\" placeholder=\"First name\" maxlength=\"50\" value=\"","<label class=\"cca-lead__consent\"><input type=\"checkbox\" name=\"rodo\"><span>Zgoda na przetwarzanie danych przez <b>TOP Cosmetics Europe</b>. Szczegóły w <a href=\"/policies/privacy-policy\" target=\"_blank\">polityce prywatności</a>.</span></label>":"<label class=\"cca-lead__consent\"><input type=\"checkbox\" name=\"rodo\"><span>I consent to my data being processed by <b>TOP Cosmetics Europe</b>. Details in the <a href=\"/policies/privacy-policy\" target=\"_blank\">privacy policy</a>.</span></label>","<p class=\"cca-lead__intro\"><b>Zostaw kontakt</b>Zapiszemy Twoje imię i e-mail w naszej bazie klientów. Gdy poprosisz o rutynę z czatu, wyślemy ją na ten adres.</p>":"<p class=\"cca-lead__intro\"><b>Leave your details</b>We'll save your name and email in our customer database. When you ask for the routine from this chat, we'll send it to this address.</p>","<p class=\"cca-lead__intro\"><b>Wysyłka rutyny</b>Podaj imię i e-mail. Zapiszemy je w naszej bazie klientów i wyślemy rutynę na ten adres.</p>":"<p class=\"cca-lead__intro\"><b>Routine by email</b>Enter your name and email. We'll save them in our customer database and send the routine to this address.</p>","Zapisz kontakt":"Save my details","Wyślij rutynę":"Send the routine","<p class=\"cca-lead__intro\"><b>Dziękujemy! ✓</b>Zapisaliśmy Twój kontakt.</p>":"<p class=\"cca-lead__intro\"><b>Thank you! ✓</b>We've saved your details.</p>","Nie udało się zapisać kontaktu. Spróbuj jeszcze raz.":"We couldn't save your details. Please try again.","Sprawdź imię i adres e-mail.":"Please check your name and email address."};
  function CBT(s){ if(CB_LANG==='pl') return s; return CB_PL_EN[s]!==undefined?CB_PL_EN[s]:s; }
  if (window.__ccaAdvisorInitialized) return;
  window.__ccaAdvisorInitialized = true;

  const CFG = window.__cca_config || {};
  const BACKEND = CFG.backend || 'https://christina-backend.o-gezei.workers.dev';
  const ENDPOINT_CHAT = BACKEND + '/api/chat';
  const ENDPOINT_LEAD = BACKEND + '/api/lead-capture';
  const ENDPOINT_EMAIL_ROUTINE = BACKEND + '/api/email-routine';

  const SESSION_KEY = 'cca2_session';
  const SESSION_TS_KEY = 'cca2_session_ts';
  const LEAD_KEY = 'cca2_lead';
  const SEG_KEY = 'cca2_segment';
  const SEEN_KEY = 'cca2_seen';
  const SESSION_TTL_MS = 30 * 60 * 1000;

  const I18N = {
    title: 'Christina AI Beauty Advisor',
    status: CBT('Online · doradca kosmetologiczno-sprzedażowy'),
    disclaimer: CBT('Pomoc w doborze produktów, nie zastępuje konsultacji kosmetologicznej.'),
    placeholder: CBT("Napisz, np. mam przebarwienia"), /* T-VF3-ADVISOR (2026-10-31) krotszy placeholder: stary mial 344 px przy 208 px miejsca na 320 px */
    welcome: CBT('Cześć{name}! ✨ <b>Jestem doradcą Christina.</b><br>Pomogę Ci dobrać linię, ułożyć rutynę pielęgnacyjną lub odpowiem na pytania o dostawę i rabat na rytuał. <em>Wybierz, jak zacząć:</em>'),
    addedToCart: CBT('Dodano do koszyka'),
    addedRoutine: CBT('Dodano {n} produktów do koszyka'),
    cartFailed: CBT('Nie udało się dodać. Spróbuj jeszcze raz.'),
    networkError: CBT('Brak połączenia. Napisz na info@christinacosmetics.pl'),
    rateLimited: CBT('Zbyt wiele wiadomości. Spróbuj za chwilę.'),
    emailSent: CBT('Wysłano na {email}'),
    emailFailed: CBT('Nie udało się wysłać. Napisz na info@christinacosmetics.pl'),
    emailDomainPending: CBT('Email jeszcze niedostępny — spróbuj za chwilę.'),
    leadSaveFailed: CBT('Nie udało się zapisać kontaktu. Spróbuj jeszcze raz.'),
    leadInvalid: CBT('Sprawdź imię i adres e-mail.'),
    inStock: CBT('Dostępny'),
    lowStock: CBT('Ostatnie sztuki'),
    outStock: CBT('Brak na stanie'),
    view: CBT('Zobacz'),
    addCart: CBT('+ Koszyk'),
    addRoutineToCart: CBT('Dodaj rutynę do koszyka'),
    emailRoutine: CBT('📧 Na email'),
    sumLabel: CBT('Razem'),
    intentsTitle: CBT('Jak mogę pomóc?'),
    issuesTitle: CBT('Wybierz, co Cię dotyczy:'),
    closeLabel: CBT('Zamknij'),
    backLabel: CBT('Wstecz'),
    segRetail: CBT('Klient'),
    segPro: CBT('Kosmetolog / Pro'),
    // Stage labels for SSE typing indicator (rev 5)
    stageThinking: CBT('Analizuję Twoje pytanie'),
    stageGenerating: CBT('Generuję rekomendację'),
    stageToolGeneric: CBT('Sprawdzam ofertę Christina'),
    stageToolSearch: CBT('Szukam pasujących produktów'),
    stageToolDetails: CBT('Sprawdzam szczegóły produktu'),
    stageToolCollection: CBT('Przeglądam linię produktów'),
    stageToolStock: CBT('Sprawdzam dostępność'),
    stageToolOrders: CBT('Sprawdzam Twoje zamówienia'),
    stageToolBundle: CBT('Liczę rabat na rytuał'),
    stageToolLead: CBT('Zapisuję dane kontaktowe')
  };

  // SSE stage → friendly label mapping
  function labelForStage(data){
    if (!data) return I18N.stageThinking;
    if (data.stage === 'thinking') return I18N.stageThinking;
    if (data.stage === 'generating') return I18N.stageGenerating;
    if (data.stage === 'tool_call' || data.stage === 'tool_result') {
      const t = (data.tool || '').toLowerCase();
      if (t.indexOf('search_product') >= 0) return I18N.stageToolSearch;
      if (t.indexOf('get_product') >= 0 || t.indexOf('product_detail') >= 0) return I18N.stageToolDetails;
      if (t.indexOf('collection') >= 0) return I18N.stageToolCollection;
      if (t.indexOf('stock') >= 0 || t.indexOf('inventory') >= 0) return I18N.stageToolStock;
      if (t.indexOf('order') >= 0) return I18N.stageToolOrders;
      if (t.indexOf('bundle') >= 0 || t.indexOf('discount') >= 0) return I18N.stageToolBundle;
      if (t.indexOf('lead') >= 0 || t.indexOf('save_contact') >= 0) return I18N.stageToolLead;
      return I18N.stageToolGeneric;
    }
    return I18N.stageThinking;
  }

  const DEFAULT_INTENTS = [
    { icon: '💎', title: CBT('Dobierz linię dla mnie'), subtitle: CBT('Quiz 7 pytań · 90 sek.'), action: 'skin_quiz' },
    { icon: '🎯', title: CBT('Mam konkretny problem'), subtitle: CBT('Przebarwienia, trądzik, SPF'), action: 'issues' },
    { icon: '🎁', title: CBT('Szukam prezentu'), subtitle: CBT('Bestsellery + zestawy'), action: 'gift' },
    { icon: '👩‍⚕️', title: CBT('Jestem kosmetologiem'), subtitle: CBT('Pełna oferta Pro · B2B'), action: 'pro_switch' },
    { icon: '📦', title: CBT('Status zamówienia'), subtitle: CBT('Dostawa, zwroty, faktura'), action: 'order' },
    { icon: '🧴', title: CBT('Pomóż znaleźć produkt'), subtitle: CBT('Po nazwie lub składniku'), action: 'search' }
  ];

  const DEFAULT_ISSUES = [
    { emoji: '🟤', name: CBT('Przebarwienia'), matched_line: 'Illustrious', collection_handle: 'illustrious' },
    { emoji: '🔴', name: CBT('Trądzik'), matched_line: 'Comodex', collection_handle: 'comodex' },
    { emoji: '⏰', name: CBT('Zmarszczki'), matched_line: 'Forever Young', collection_handle: 'forever-young' },
    { emoji: '🌸', name: CBT('Wrażliwość'), matched_line: 'Unstress', collection_handle: 'unstress' },
    { emoji: '💧', name: CBT('Sucha skóra'), matched_line: 'Bio Phyto', collection_handle: 'bio-phyto' },
    { emoji: '✨', name: CBT('Brak blasku'), matched_line: 'MUSE', collection_handle: 'muse' },
    { emoji: '☀️', name: CBT('SPF / słońce'), matched_line: 'Sun Sheen', collection_handle: 'sun-sheen' },
    { emoji: '🏙️', name: CBT('Smog · stres'), matched_line: 'Unstress', collection_handle: 'unstress' }
  ];

  let ui = null, isOpen = false, isSending = false, messageCount = 0;
  let leadCaptured = false, segment = 'retail', typingUpgradeTimer = null;
  let messageHistory = [];
  // rev 8 — progressive streaming bubble (filled by SSE text_delta events)
  let streamingBubble = null;

  function track(eventName, params) {
    try {
      window.dataLayer = window.dataLayer || [];
      const base = {
        event: eventName,
        cca_session_id: analyticsSessionId(),
        cca_segment: segment,
        cca_page_type: CFG.page_type || null,
        cca_customer_segment: (window.__cca_customer && window.__cca_customer.segment) || 'anon'
      };
      window.dataLayer.push(Object.assign(base, params || {}));
    } catch(e) {}
  }

  function priceCentsFromString(price) {
    if (typeof price !== 'string') return null;
    const m = price.match(/[\d\s.,]+/);
    if (!m) return null;
    const n = parseFloat(m[0].replace(/\s/g, '').replace(',', '.'));
    return isNaN(n) ? null : Math.round(n * 100);
  }

  /* T99-INLINE (2026-10-13) — SESSION ID Z CSPRNG
     sessionId wiąże po stronie backendu potwierdzenie e-maila kodem jednorazowym, więc musi być
     nie do odgadnięcia: 'cca2_' + 32 znaki hex z crypto.getRandomValues (128 bitów), razem 37 znaków
     (limit backendu: string <= 64). Klucze localStorage: cca2_session, cca2_session_ts, TTL 30 min
     liczony od ostatniego użycia. ID w innym formacie (niezgodny z SESSION_ID_RE) jest wymieniany
     przy pierwszym odczycie. Gdy localStorage nie działa, ID żyje w pamięci strony, więc formularz
     kontaktu i czat używają tego samego ID. Math.random tylko jako awaryjny fallback dla przeglądarki
     bez Web Crypto (w praktyce nieosiągalny: plik wymaga async/await). */
  const SESSION_ID_RE = /^cca2_[0-9a-f]{32}$/;
  let memSessionId = null, memSessionTs = 0;

  function newSessionId(){
    let hex = '';
    try {
      const c = window.crypto;
      if (c && typeof c.getRandomValues === 'function') {
        const b = new Uint8Array(16);
        c.getRandomValues(b);
        for (let i = 0; i < b.length; i++) hex += (b[i] < 16 ? '0' : '') + b[i].toString(16);
      }
    } catch(e){ hex = ''; }
    if (hex.length !== 32) {
      hex = '';
      while (hex.length < 32) hex += Math.floor(Math.random() * 16).toString(16);
    }
    return 'cca2_' + hex;
  }

  function getSessionId(){
    const now = Date.now();
    try {
      const existing = localStorage.getItem(SESSION_KEY);
      const ts = parseInt(localStorage.getItem(SESSION_TS_KEY) || '0', 10);
      if (existing && SESSION_ID_RE.test(existing) && ts && (now - ts) < SESSION_TTL_MS) {
        localStorage.setItem(SESSION_TS_KEY, String(now));
        memSessionId = existing; memSessionTs = now;
        return existing;
      }
    } catch(e){}
    if (!memSessionId || (now - memSessionTs) >= SESSION_TTL_MS) memSessionId = newSessionId();
    memSessionTs = now;
    try { localStorage.setItem(SESSION_KEY, memSessionId); localStorage.setItem(SESSION_TS_KEY, String(now)); } catch(e){}
    return memSessionId;
  }

  /* T99-INLINE (2026-10-13) — PSEUDONIM SESJI W ANALITYCE
     Do window.dataLayer trafia 12 pierwszych znaków sessionId ('cca2_' + 7 hex) do łączenia zdarzeń,
     nigdy pełne ID. */
  function analyticsSessionId(){ return getSessionId().slice(0, 12); }

  function getSegment(){
    try { return localStorage.getItem(SEG_KEY) || (window.__cca_customer && window.__cca_customer.segment) || 'retail'; }
    catch(e) { return 'retail'; }
  }
  function setSegment(seg){ segment = seg; try { localStorage.setItem(SEG_KEY, seg); } catch(e){} }

  function getLead(){
    try { const raw = localStorage.getItem(LEAD_KEY); if (raw) return JSON.parse(raw); } catch(e){}
    return null;
  }

  function escapeHTML(s){ return (s||'').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c])); }
  function sanitizeBotHTML(html){
    return (html||'')
      .replace(/<(?!\/?(?:b|strong|em|br|a)\b)[^>]+>/gi, '')
      .replace(/<a([^>]*)>/gi, (m, attrs) => {
        const h = attrs.match(/href\s*=\s*["']([^"']+)["']/i);
        if (!h) return '';
        const href = h[1];
        if (!/^(\/|https?:\/\/)/.test(href)) return '';
        return '<a href="' + escapeHTML(href) + '" target="_blank" rel="noopener">';
      });
  }

  function buildUI(){
    const seen = (()=>{ try { return !!localStorage.getItem(SEEN_KEY); } catch(e){return false;} })();
    const launcher = document.createElement('button');
    launcher.className = 'cca-launcher' + (seen ? '' : ' cca-launcher--pulse');
    launcher.type = 'button';
    launcher.setAttribute('aria-label', CBT('Otwórz Christina AI Advisor'));
    launcher.innerHTML = '<svg class="cca-launcher__icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z" stroke-linecap="round" stroke-linejoin="round"/></svg><svg class="cca-launcher__sparkle" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2l2.4 7.6L22 12l-7.6 2.4L12 22l-2.4-7.6L2 12l7.6-2.4L12 2z"/></svg>';
    document.body.appendChild(launcher);
    setTimeout(()=>launcher.classList.remove('cca-launcher--pulse'), 5000);

    const panel = document.createElement('div');
    panel.className = 'cca-panel';
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-label', I18N.title);
    panel.innerHTML = '<div class="cca-header"><div class="cca-avatar">CC</div><div class="cca-h-info"><p class="cca-h-title">' + I18N.title + '</p><div class="cca-h-status">' + I18N.status + '</div></div><button class="cca-close" type="button" aria-label="' + I18N.closeLabel + '"><svg viewBox="0 0 24 24"><path d="M18 6L6 18M6 6l12 12" stroke-linecap="round" stroke-linejoin="round"/></svg></button></div>'
      + '<div class="cca-segment" role="tablist"><button class="cca-segment__opt" data-seg="retail" type="button">' + I18N.segRetail + '</button><button class="cca-segment__opt" data-seg="pro" type="button">' + I18N.segPro + '</button></div>'
      + '<div class="cca-disclaimer"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/></svg><span>' + I18N.disclaimer + '</span></div>'
      + '<div class="cca-msgs" role="log" aria-live="polite"></div>'
      + '<div class="cca-quick"></div>'
      + '<form class="cca-input-area" autocomplete="off"><textarea class="cca-input" placeholder="' + I18N.placeholder + CBT('" rows="1" maxlength="2000"></textarea><button class="cca-send" type="submit" aria-label="Wyślij"><svg viewBox="0 0 24 24"><path d="M22 2L11 13M22 2l-7 20-4-9-9-4 20-7z" stroke-linecap="round" stroke-linejoin="round"/></svg></button></form>')
      + CBT('<div class="cca-footer">Wspierane przez Claude · Christina Cosmetics 2026</div>');
    document.body.appendChild(panel);

    const toast = document.createElement('div');
    toast.className = 'cca-toast';
    toast.innerHTML = '<span class="cca-toast__check">✓</span><span class="cca-toast__text"></span>';
    document.body.appendChild(toast);
    return { launcher, panel, toast };
  }

  function showToast(text){
    if (!ui) return;
    ui.toast.querySelector('.cca-toast__text').textContent = text;
    ui.toast.classList.add('cca-toast--visible');
    clearTimeout(showToast._t);
    showToast._t = setTimeout(()=>ui.toast.classList.remove('cca-toast--visible'), 1800);
  }
  function scrollBottom(){ const m = ui.panel.querySelector('.cca-msgs'); requestAnimationFrame(()=>{ m.scrollTop = m.scrollHeight; }); }
  function addBot(html){ const m = ui.panel.querySelector('.cca-msgs'); const d = document.createElement('div'); d.className = 'cca-msg cca-msg--bot'; d.innerHTML = sanitizeBotHTML(html); m.appendChild(d); scrollBottom(); }
  function addUser(t){ const m = ui.panel.querySelector('.cca-msgs'); const d = document.createElement('div'); d.className = 'cca-msg cca-msg--user'; d.textContent = t; m.appendChild(d); scrollBottom(); }
  function addError(t){ const m = ui.panel.querySelector('.cca-msgs'); const d = document.createElement('div'); d.className = 'cca-msg cca-msg--error'; d.textContent = t; m.appendChild(d); scrollBottom(); }

  // rev 8 — create or return the active streaming bubble for progressive text_delta
  function ensureStreamingBubble(){
    if (streamingBubble && streamingBubble.isConnected) return streamingBubble;
    const m = ui.panel.querySelector('.cca-msgs');
    const d = document.createElement('div');
    d.className = 'cca-msg cca-msg--bot cca-msg--streaming';
    d.dataset.streaming = '1';
    d.textContent = '';
    m.appendChild(d);
    streamingBubble = d;
    return d;
  }

  function showTyping(){
    hideTyping();
    const m = ui.panel.querySelector('.cca-msgs');
    const t = document.createElement('div');
    t.className = 'cca-typing'; t.id = 'cca2-typing';
    t.innerHTML = '<span class="cca-typing__dot"></span><span class="cca-typing__dot"></span><span class="cca-typing__dot"></span>';
    m.appendChild(t); scrollBottom();
    // Fallback timer — upgrade to analyzing label after 2s if no SSE stage arrives
    if (typingUpgradeTimer) clearTimeout(typingUpgradeTimer);
    typingUpgradeTimer = setTimeout(()=>{
      updateTypingLabel(I18N.stageToolGeneric);
    }, 2000);
  }
  function hideTyping(){ if (typingUpgradeTimer) { clearTimeout(typingUpgradeTimer); typingUpgradeTimer = null; } const t = ui.panel.querySelector('#cca2-typing'); if (t) t.remove(); }

  // rev 5 — updates the typing label with friendly per-stage Polish copy
  function updateTypingLabel(label){
    if (!ui) return;
    const tEl = ui.panel.querySelector('#cca2-typing');
    if (!tEl) return;
    tEl.classList.add('cca-typing--analyzing');
    tEl.innerHTML = '<span class="cca-typing__label">' + escapeHTML(label) + '</span><span class="cca-typing__ellipsis"></span>';
    scrollBottom();
  }

  function stockState(p){ if (p.stock_state) return p.stock_state; if (p.available === false) return 'out'; return 'high'; }
  function stockLabel(s){ return s === 'out' ? I18N.outStock : s === 'low' ? I18N.lowStock : I18N.inStock; }

  // Rev 9 (Audyt #3): Details panel — expandable z structured fields
  function renderDetailsRows(p){
    var rows = [];
    if (p.spf) rows.push(['SPF', escapeHTML(p.spf)]);
    if (p.skin_type) rows.push([CBT('Dla skóry'), escapeHTML(p.skin_type)]);
    if (p.problems) rows.push([CBT('Problemy'), escapeHTML(p.problems)]);
    if (p.actions) rows.push([CBT('Działanie'), escapeHTML(p.actions)]);
    if (p.special_function) rows.push([CBT('Funkcja'), escapeHTML(p.special_function)]);
    if (p.age_group) rows.push([CBT('Wiek'), escapeHTML(p.age_group)]);
    if (p.volume) rows.push([CBT('Pojemność'), escapeHTML(p.volume)]);
    if (p.packaging) rows.push([CBT('Opakowanie'), escapeHTML(p.packaging)]);
    if (p.ean) rows.push(['EAN', escapeHTML(p.ean)]);
    if (p.sku) rows.push(['SKU', escapeHTML(p.sku)]);
    if (p.contraindications) rows.push([CBT('Przeciwwskazania'), escapeHTML(p.contraindications)]);
    if (p.recommended_for) rows.push([CBT('Polecane dla'), escapeHTML(p.recommended_for)]);
    if (p.ingredients_summary) rows.push([CBT('Składniki kluczowe'), escapeHTML(p.ingredients_summary)]);
    if (p.ingredients_inci) {
      var inci = '<span class="cca-prod__inci">' + escapeHTML(p.ingredients_inci) + '</span>';
      rows.push(['INCI', inci]);
    }
    if (p.rating && p.reviews_count) rows.push([CBT('Oceny'), escapeHTML(String(p.rating)) + ' / 5 · ' + escapeHTML(String(p.reviews_count)) + CBT(' opinii')]);
    return rows;
  }

  function renderProductCard(p){
    const card = document.createElement('div');
    card.className = 'cca-prod';
    const _vid = p.variant_numeric_id || (p.variant_id ? parseInt(p.variant_id.split('/').pop(), 10) : null);
    if (_vid) card.dataset.variantId = String(_vid);
    if (p.line_color) card.style.setProperty('--cca-line-color', p.line_color);
    const state = stockState(p);
    const stockClass = state === 'out' ? 'cca-prod__stock--out' : state === 'low' ? 'cca-prod__stock--low' : '';
    const badge = p.badge ? '<span class="cca-prod__badge' + (p.badge.toLowerCase().indexOf('pro') >= 0 ? ' cca-prod__badge--neutral' : '') + '">' + escapeHTML(p.badge) + '</span>' : '';
    const cmp = p.compare_at_price ? '<s>' + escapeHTML(p.compare_at_price) + '</s>' : '';
    const reason = p.reason ? '<div class="cca-prod__reason">' + escapeHTML(p.reason) + '</div>' : '';
    const blurb = p.hero_blurb ? '<div class="cca-prod__blurb">' + escapeHTML(p.hero_blurb) + '</div>' : '';
    const tbadges = (p.trust_badges && p.trust_badges.length) ? '<div class="cca-prod__tbadges">' + p.trust_badges.slice(0, 4).map(tb => '<span class="cca-prod__tbadge" title="' + escapeHTML(tb.tooltip || '') + '">' + (tb.icon_svg || '') + '<span>' + escapeHTML(tb.label || tb.code || '') + '</span></span>').join('') + '</div>' : '';
    var detailsRows = renderDetailsRows(p);
    var hasDetails = detailsRows.length > 0;
    var detailsHTML = '';
    if (hasDetails) {
      detailsHTML = CBT('<button type="button" class="cca-prod__details-toggle" aria-expanded="false">Szczegóły produktu</button>')
        + '<div class="cca-prod__details">'
        + '<dl>' + detailsRows.map(function(row){ return '<dt>' + row[0] + '</dt><dd>' + row[1] + '</dd>'; }).join('') + '</dl>'
        + '</div>';
    }
    const url = p.url || (p.handle ? '/products/' + p.handle : '#');
    card.innerHTML =
      '<a href="' + escapeHTML(url) + '" class="cca-prod__img" target="_blank" rel="noopener">' + badge + '<img src="' + escapeHTML(p.image||'') + '" alt="' + escapeHTML(p.title||'') + '" loading="lazy"></a>'
      + '<div class="cca-prod__body">'
      + (p.line ? '<div class="cca-prod__line">' + escapeHTML(p.line) + '</div>' : '')
      + '<a href="' + escapeHTML(url) + '" class="cca-prod__title" target="_blank" rel="noopener">' + escapeHTML(p.title||'') + '</a>'
      + (p.subtitle ? '<div class="cca-prod__sub">' + escapeHTML(p.subtitle) + '</div>' : '')
      + blurb
      + reason
      + tbadges
      + detailsHTML
      + ((p.frequently_bought_with && p.frequently_bought_with.length) ? CBT('<div class="cca-prod__fbw"><div class="cca-prod__fbw-title">Często kupowane razem</div><div class="cca-prod__fbw-list">') + p.frequently_bought_with.slice(0,3).map(function(fb){ return '<a class="cca-prod__fbw-item" href="' + escapeHTML(fb.url||('/products/'+fb.handle)) + '" title="' + escapeHTML(fb.title||'') + '">' + (fb.image ? '<img src="' + escapeHTML(fb.image) + '" alt="' + escapeHTML(fb.title||'') + '" loading="lazy">' : '<div class="cca-prod__fbw-noimg"></div>') + '<span class="cca-prod__fbw-name">' + escapeHTML((fb.title||'').slice(0,30)) + '</span>' + (fb.price ? '<span class="cca-prod__fbw-price">' + escapeHTML(String(fb.price) + ' ' + (fb.currency||'PLN')) + '</span>' : '') + '</a>'; }).join('') + '</div></div>' : '')
      + '<div class="cca-prod__row"><span class="cca-prod__price">' + cmp + escapeHTML(p.price||'') + '</span><span class="cca-prod__stock ' + stockClass + '">' + stockLabel(state) + '</span></div>'
      + '<div class="cca-prod__actions"><a class="cca-prod__btn cca-prod__btn--out" href="' + escapeHTML(url) + '" target="_blank" rel="noopener">' + I18N.view + '</a><button class="cca-prod__btn cca-prod__btn--solid" type="button"' + (state==='out'?' disabled':'') + '>' + I18N.addCart + '</button></div>'
      + '</div>';
    card.querySelector('.cca-prod__img').addEventListener('click', () => track('cca_product_card_click', { product_handle: p.handle, product_line: p.line, target: 'image' }));
    card.querySelector('.cca-prod__title').addEventListener('click', () => track('cca_product_card_click', { product_handle: p.handle, product_line: p.line, target: 'title' }));
    card.querySelector('.cca-prod__btn--solid').addEventListener('click', ()=>addToCart(p, card));
    card.querySelectorAll('.cca-prod__details-toggle').forEach(function(btn){
      btn.addEventListener('click', function(){
        var det = btn.nextElementSibling;
        if (!det) return;
        var open = det.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        btn.textContent = open ? CBT('Ukryj szczegóły') : CBT('Szczegóły produktu');
      });
    });
    return card;
  }

  function addProducts(arr){
    if (!arr || !arr.length) return;
    const m = ui.panel.querySelector('.cca-msgs');
    const wrap = document.createElement('div');
    wrap.className = 'cca-prod-list';
    arr.forEach(p => wrap.appendChild(renderProductCard(p)));
    m.appendChild(wrap); scrollBottom();
    track('cca_products_shown', { product_count: arr.length, product_lines: Array.from(new Set(arr.map(p => p.line).filter(Boolean))).join('|') });
  }

  function addRoutine(r){
    if (!r || !r.steps) return;
    const m = ui.panel.querySelector('.cca-msgs');
    const wrap = document.createElement('div'); wrap.className = 'cca-routine';
    function renderStep(s){
      const p = s.product || {};
      var detailsRows = renderDetailsRows(p);
    var hasDetails = detailsRows.length > 0;
    var detailsHTML = '';
    if (hasDetails) {
      detailsHTML = CBT('<button type="button" class="cca-prod__details-toggle" aria-expanded="false">Szczegóły produktu</button>')
        + '<div class="cca-prod__details">'
        + '<dl>' + detailsRows.map(function(row){ return '<dt>' + row[0] + '</dt><dd>' + row[1] + '</dd>'; }).join('') + '</dl>'
        + '</div>';
    }
    const url = p.url || (p.handle ? '/products/' + p.handle : '#');
      return '<div class="cca-routine__step"><div class="cca-routine__num">' + s.step + '</div><a href="' + escapeHTML(url) + '" class="cca-routine__img" target="_blank" rel="noopener"><img src="' + escapeHTML(p.image||'') + '" alt="" loading="lazy"></a><div class="cca-routine__info"><div class="cca-routine__cat">' + escapeHTML(s.category||'') + '</div><a href="' + escapeHTML(url) + '" class="cca-routine__name" target="_blank" rel="noopener">' + escapeHTML(p.title||'') + '</a></div></div>';
    }
    var amSteps = (r.steps||[]).filter(function(s){return s.time_of_day==='AM';});
    var pmSteps = (r.steps||[]).filter(function(s){return s.time_of_day==='PM';});
    var anySteps = (r.steps||[]).filter(function(s){return !s.time_of_day || s.time_of_day==='any';});
    var hasSplit = (amSteps.length > 0 || pmSteps.length > 0);
    var stepsHTML;
    if (hasSplit) {
      stepsHTML = '';
      if (amSteps.length || anySteps.length) {
        stepsHTML += CBT('<div class="cca-routine__section cca-routine__section--am"><div class="cca-routine__section-title">☀️ Poranna rutyna</div>') + amSteps.concat(anySteps).map(renderStep).join('') + '</div>';
      }
      if (pmSteps.length) {
        stepsHTML += CBT('<div class="cca-routine__section cca-routine__section--pm"><div class="cca-routine__section-title">🌙 Wieczorna rutyna</div>') + pmSteps.map(renderStep).join('') + '</div>';
      }
    } else {
      stepsHTML = (r.steps||[]).map(renderStep).join('');
    }
    const warningHTML = r.warning_copy ? '<div class="cca-routine__warning">' + escapeHTML(r.warning_copy) + '</div>' : '';
    const disc = r.discount_label ? '<span class="cca-routine__discount">' + escapeHTML(r.discount_label) + '</span>' : '';
    const pre = r.total_price_pre ? '<s>' + escapeHTML(r.total_price_pre) + '</s>' : '';
    wrap.innerHTML = '<div class="cca-routine__hdr"><div class="cca-routine__icon">' + (r.icon || '🌿') + '</div><div><div class="cca-routine__title">' + escapeHTML(r.title||CBT('Rutyna')) + '</div>' + (r.subtitle ? '<div class="cca-routine__sub">' + escapeHTML(r.subtitle) + '</div>' : '') + '</div></div>'
      + warningHTML
      + stepsHTML
      + '<div class="cca-routine__totals"><span class="cca-routine__label">' + I18N.sumLabel + ' (' + r.steps.length + ')</span><div class="cca-routine__price">' + pre + escapeHTML(r.total_price_post||'') + disc + '</div></div>'
      + '<div class="cca-routine__cta"><button class="cca-routine__cta-btn cca-routine__cta-btn--primary" type="button" data-act="add-all">' + I18N.addRoutineToCart + '</button><button class="cca-routine__cta-btn cca-routine__cta-btn--ghost" type="button" data-act="email">' + I18N.emailRoutine + '</button></div>';
    wrap.querySelector('[data-act="add-all"]').addEventListener('click', e => addRoutineToCart(r, e.currentTarget));
    wrap.querySelector('[data-act="email"]').addEventListener('click', ()=>emailRoutine(r));
    m.appendChild(wrap); scrollBottom();
    track('cca_routine_shown', { step_count: r.steps.length, total_price: r.total_price_post, discount_label: r.discount_label || null, routine_title: r.title });
  }

  function addQuiz(q){
    if (!q) return;
    const m = ui.panel.querySelector('.cca-msgs');
    const wrap = document.createElement('div'); wrap.className = 'cca-quiz';
    const opts = (q.options||[]).map(o => {
      const val = (typeof o === 'string') ? o : (o.value || o.label || '');
      const lbl = (typeof o === 'string') ? o : (o.label || o.value || '');
      const hint = (typeof o === 'object' && o.hint) ? '<small>' + escapeHTML(o.hint) + '</small>' : '';
      return '<button class="cca-quiz__opt" type="button" data-val="' + escapeHTML(val) + '">' + escapeHTML(lbl) + hint + '</button>';
    }).join('');
    const progress = q.total ? ((q.step / q.total) * 100) : 0;
    wrap.innerHTML = '<div class="cca-quiz__progress"><div class="cca-quiz__progress-bar" style="width:' + progress + CBT('%"></div></div><div class="cca-quiz__step">Krok ') + (q.step||1) + CBT(' z ') + (q.total||6) + '</div><h4 class="cca-quiz__q">' + escapeHTML(q.question||'') + '</h4><div class="cca-quiz__opts">' + opts + '</div>';
    wrap.querySelectorAll('.cca-quiz__opt').forEach(b => {
      b.addEventListener('click', ()=>{
        wrap.style.opacity = '.6'; wrap.style.pointerEvents = 'none';
        addUser((b.firstChild && b.firstChild.nodeValue ? b.firstChild.nodeValue : b.textContent).replace(/\s+/g,' ').trim());
        track('cca_quiz_step_answered', { quiz_step: q.step, quiz_total: q.total, quiz_value: b.dataset.val });
        if (q.step >= (q.total || 6)) track('cca_quiz_completed', { quiz_total: q.total });
        sendMessage(b.dataset.val, { quiz_step: q.step, quiz_value: b.dataset.val });
      });
    });
    m.appendChild(wrap); scrollBottom();
    if (q.step === 1) track('cca_quiz_started', { quiz_total: q.total });
    track('cca_quiz_step_shown', { quiz_step: q.step, quiz_total: q.total });
  }

  function addIntents(items){
    const m = ui.panel.querySelector('.cca-msgs');
    const wrap = document.createElement('div'); wrap.className = 'cca-intents';
    items.forEach(x => {
      const b = document.createElement('button');
      b.type = 'button'; b.className = 'cca-intent';
      b.innerHTML = '<span class="cca-intent__icon">' + escapeHTML(x.icon||'•') + '</span><span class="cca-intent__title">' + escapeHTML(x.title||'') + '</span>' + (x.subtitle ? '<span class="cca-intent__sub">' + escapeHTML(x.subtitle) + '</span>' : '');
      b.addEventListener('click', ()=>handleIntent(x));
      wrap.appendChild(b);
    });
    m.appendChild(wrap); scrollBottom();
  }

  function addIssues(items){
    const m = ui.panel.querySelector('.cca-msgs');
    const wrap = document.createElement('div'); wrap.className = 'cca-issues';
    items.forEach(x => {
      const b = document.createElement('button');
      b.type = 'button'; b.className = 'cca-issue';
      b.innerHTML = '<span class="cca-issue__emoji">' + escapeHTML(x.emoji||'•') + '</span><span class="cca-issue__name">' + escapeHTML(x.name||'') + '</span>' + (x.matched_line ? '<span class="cca-issue__line">' + escapeHTML(x.matched_line) + '</span>' : '');
      b.addEventListener('click', ()=>{
        track('cca_issue_click', { issue: x.name, matched_line: x.matched_line, collection_handle: x.collection_handle });
        addUser(x.name);
        sendMessage(CBT('Mam problem: ') + x.name, { intent: 'skin_issue', issue: x.name, matched_line: x.matched_line, collection_handle: x.collection_handle });
      });
      wrap.appendChild(b);
    });
    m.appendChild(wrap); scrollBottom();
  }

  function setQuickReplies(arr){
    const q = ui.panel.querySelector('.cca-quick');
    q.innerHTML = '';
    if (!arr || !arr.length) return;
    arr.forEach(t => {
      const b = document.createElement('button');
      b.type = 'button'; b.className = 'cca-quick__btn'; b.textContent = t;
      b.addEventListener('click', ()=>{
        track('cca_quick_reply_click', { reply_text: t });
        addUser(t); sendMessage(t);
      });
      q.appendChild(b);
    });
  }

  function handleIntent(x){
    track('cca_intent_click', { intent_action: x.action, intent_title: x.title });
    addUser(x.title);
    if (x.action === 'skin_quiz') sendMessage(CBT('Chcę kwiz skóry'), { intent: 'skin_quiz_start' });
    else if (x.action === 'issues') { addBot(I18N.issuesTitle); addIssues(DEFAULT_ISSUES); }
    else if (x.action === 'pro_switch') {
      setSegment('pro');
      ui.panel.querySelectorAll('.cca-segment__opt').forEach(b => b.classList.toggle('cca-segment__opt--active', b.dataset.seg === 'pro'));
      sendMessage(CBT('Jestem kosmetologiem, pokaż mi ofertę Pro'), { intent: 'pro_segment' });
    }
    else if (x.action === 'order') sendMessage(CBT('Mam pytanie o moje zamówienie'), { intent: 'order_status' });
    else if (x.action === 'gift') sendMessage(CBT('Szukam prezentu'), { intent: 'gift' });
    else if (x.action === 'search') { ui.panel.querySelector('.cca-input').focus(); addBot(CBT('Napisz w pole poniżej, czego szukasz — nazwa, składnik aktywny lub problem.')); }
    else sendMessage(x.title, { intent: x.action || 'other' });
  }

  async function addToCart(product, cardEl){
    const vid = product.variant_numeric_id || (product.variant_id ? parseInt(product.variant_id.split('/').pop(), 10) : null);
    if (!vid) {
      track('cca_add_to_cart_fallback', { product_handle: product.handle, reason: 'no_variant_id' });
      window.open(product.url || ('/products/' + product.handle), '_blank');
      return;
    }
    const btn = cardEl ? cardEl.querySelector('.cca-prod__btn--solid') : null;
    if (btn) { btn.disabled = true; btn.textContent = '...'; }
    try {
      const r = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: vid, quantity: 1 }] }) });
      if (!r.ok) throw new Error('cart add failed');
      showToast(I18N.addedToCart);
      bumpCartCount(1);
      const priceCents = priceCentsFromString(product.price);
      track('cca_add_to_cart', {
        product_handle: product.handle,
        variant_id: vid,
        product_line: product.line,
        product_title: product.title,
        price_cents: priceCents,
        currency: 'PLN'
      });
      try {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ ecommerce: null });
        window.dataLayer.push({
          event: 'add_to_cart',
          ecommerce: {
            currency: 'PLN',
            value: priceCents != null ? priceCents / 100 : undefined,
            items: [{
              item_id: String(vid),
              item_name: product.title,
              item_brand: 'Christina',
              item_category: product.line,
              price: priceCents != null ? priceCents / 100 : undefined,
              quantity: 1
            }]
          },
          cca_source: 'advisor',
          cca_session_id: analyticsSessionId(),
          cca_segment: segment,
          cca_customer_segment: (window.__cca_customer && window.__cca_customer.segment) || 'anon',
          cca_page_type: CFG.page_type || null
        });
      } catch(e) {}
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      document.dispatchEvent(new CustomEvent('cca:product-added', { detail: product }));
    } catch(e) {
      track('cca_add_to_cart_error', { product_handle: product.handle, error: String(e && e.message || e) });
      showToast(I18N.cartFailed);
    }
    finally { if (btn) { btn.disabled = false; btn.textContent = I18N.addCart; } }
  }

  async function addRoutineToCart(r, btn){
    const items = (r.steps||[]).map(s => s.product).filter(p => p).map(p => ({ id: p.variant_numeric_id || (p.variant_id ? parseInt(p.variant_id.split('/').pop(), 10) : null), quantity: 1, _p: p })).filter(it => it.id);
    if (!items.length) {
      track('cca_routine_add_to_cart_fallback', { reason: 'no_variant_ids' });
      showToast(I18N.cartFailed); return;
    }
    const orig = btn.textContent; btn.disabled = true; btn.textContent = '...';
    try {
      const resp = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items.map(it => ({ id: it.id, quantity: it.quantity })) }) });
      if (!resp.ok) throw new Error('routine cart failed');
      showToast(I18N.addedRoutine.replace('{n}', items.length));
      bumpCartCount(items.length);
      const totalCents = priceCentsFromString(r.total_price_post) || items.reduce((s, it) => s + (priceCentsFromString(it._p.price) || 0), 0);
      track('cca_routine_add_to_cart', {
        routine_title: r.title,
        step_count: items.length,
        total_price_cents: totalCents,
        discount_label: r.discount_label || null
      });
      try {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ ecommerce: null });
        window.dataLayer.push({
          event: 'add_to_cart',
          ecommerce: {
            currency: 'PLN',
            value: totalCents / 100,
            items: items.map(it => ({
              item_id: String(it.id),
              item_name: it._p.title,
              item_brand: 'Christina',
              item_category: it._p.line,
              price: (priceCentsFromString(it._p.price) || 0) / 100,
              quantity: 1
            }))
          },
          cca_source: 'advisor_routine',
          cca_session_id: analyticsSessionId(),
          cca_segment: segment,
          cca_customer_segment: (window.__cca_customer && window.__cca_customer.segment) || 'anon',
          cca_page_type: CFG.page_type || null,
          routine_title: r.title,
          step_count: items.length,
          discount_label: r.discount_label || null
        });
      } catch(e) {}
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      document.dispatchEvent(new CustomEvent('cca:routine-added', { detail: r }));
    } catch(e) {
      track('cca_routine_add_to_cart_error', { error: String(e && e.message || e) });
      showToast(I18N.cartFailed);
    }
    finally { btn.disabled = false; btn.textContent = orig; }
  }

  function bumpCartCount(n){
    if (!ui) return;
    const b = ui.launcher.querySelector('.cca-launcher__badge');
    const cur = parseInt((b && b.textContent) || '0', 10) || 0;
    const next = cur + n;
    if (b) b.textContent = next;
    else { const e = document.createElement('span'); e.className = 'cca-launcher__badge'; e.textContent = next; ui.launcher.appendChild(e); }
  }

  /* T99-INLINE (2026-10-13) — JEDNA WYSYŁKA I JEDEN FORMULARZ NA RUTYNĘ
     Kolejne kliknięcia „Na email” w trakcie wysyłki są ignorowane, a przy otwartym formularzu kontaktu
     dla tej rutyny przewijamy do niego zamiast dodawać nowy. Stan w WeakSet/WeakMap, nie w obiekcie
     rutyny (ten trafia do body żądania). */
  const routineSending = new WeakSet();
  const routineLeadForm = new WeakMap();
  function openRoutineLeadForm(r){
    const f = routineLeadForm.get(r);
    if (f && f.isConnected && f.querySelector('.cca-lead__submit')) { f.scrollIntoView({ block: 'nearest' }); return true; }
    return false;
  }

  async function emailRoutine(r){
    if (routineSending.has(r) || openRoutineLeadForm(r)) return;
    track('cca_email_routine_click', { routine_title: r.title, step_count: (r.steps || []).length });
    let lead = getLead();
    if (!lead || !lead.email) { addBot(CBT('<b>Mogę wysłać Ci tę rutynę na email.</b><br>Zostaw kontakt poniżej:')); routineLeadForm.set(r, addLeadCapture(true, l => postEmailRoutine(r, l))); return; }
    postEmailRoutine(r, lead);
  }

  async function postEmailRoutine(r, lead, retried){
    if (routineSending.has(r)) return;
    routineSending.add(r);
    try { await postEmailRoutineOnce(r, lead, retried); }
    finally { routineSending.delete(r); }
  }

  async function postEmailRoutineOnce(r, lead, retried){
    let resp = null, body = null;
    try {
      resp = await fetch(ENDPOINT_EMAIL_ROUTINE, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ sessionId: getSessionId(), email: lead.email, firstName: lead.firstName, routine: r })
      });
      try { body = await resp.json(); } catch(e) { body = null; }
    } catch(e) {
      track('cca_email_routine_error', { stage: 'network', error: String(e && e.message || e) });
      showToast(I18N.networkError);
      return;
    }
    if (resp.ok && body && body.ok) {
      track('cca_email_routine_sent', { resend_id: body.id || null, routine_title: r.title, recipient_domain: (lead.email.split('@')[1] || '') });
      showToast(I18N.emailSent.replace('{email}', lead.email));
      return;
    }
    /* T99-INLINE (2026-10-13) — 403 LEAD_REQUIRED
       Backend wysyła rutynę tylko na adres zapisany w tej sesji czatu (ważny 30 min). Gdy go brak,
       jeden raz pokazujemy formularz kontaktu i ponawiamy wysyłkę; kolejny 403 = zwykły komunikat błędu. */
    if (resp.status === 403 && body && body.code === 'LEAD_REQUIRED' && !retried) {
      track('cca_email_routine_lead_required', { routine_title: r.title });
      addBot(CBT('<b>Mogę wysłać Ci tę rutynę na email.</b><br>Zostaw kontakt poniżej:'));
      routineLeadForm.set(r, addLeadCapture(true, l => postEmailRoutine(r, l, true), 'lead_required'));
      return;
    }
    const upstream = body && body.upstream;
    const upstreamMsg = upstream && (upstream.message || upstream.name);
    const isDomainIssue = upstreamMsg && /domain|verify|verified|sender/i.test(upstreamMsg);
    track('cca_email_routine_error', {
      stage: 'upstream',
      status: resp.status,
      upstream_message: upstreamMsg || (body && body.error) || null,
      domain_issue: !!isDomainIssue
    });
    if (isDomainIssue) showToast(I18N.emailDomainPending);
    else if (resp.status === 429) showToast(I18N.rateLimited);
    else showToast(I18N.emailFailed);
  }

  /* T99-INLINE (2026-10-13) — FORMULARZ KONTAKTU: TEKSTY, WALIDACJA, BŁĘDY
     Teksty opisują to, co się dzieje: zapis imienia i e-maila w bazie klientów i wysyłkę rutyny
     na prośbę klienta (Humanizer + QA faktów). Walidacja zgodna z backendem: imię 2-50 znaków,
     e-mail w formacie przyjmowanym także przy wysyłce rutyny. Sukces tylko przy r.ok; 400 = prośba
     o sprawdzenie danych, 429 = limit, inne błędy = toast, przycisk wraca, cb nie jest wołany.
     Pola wypełniane osobno z danych zalogowanego klienta albo ostatniego kontaktu (cca2_lead).
     Zwraca element formularza (null, gdy nie został dodany). */
  const LEAD_EMAIL_RE = /^[a-z0-9._%+\-]+@[a-z0-9](?:[a-z0-9\-]*[a-z0-9])?(?:\.[a-z0-9](?:[a-z0-9\-]*[a-z0-9])?)*\.[a-z]{2,24}$/;

  function addLeadCapture(force, cb, ctxName){
    if (leadCaptured && !force) return null;
    const ctx = ctxName || (force ? 'email_request' : 'nudge');
    const cust = window.__cca_customer || {};
    const prev = getLead() || {};
    const preName = String(cust.firstName || prev.firstName || '');
    const preEmail = String(cust.email || prev.email || '');
    const m = ui.panel.querySelector('.cca-msgs');
    const wrap = document.createElement('div');
    wrap.className = 'cca-lead';
    const submitLabel = force ? CBT('Wyślij rutynę') : CBT('Zapisz kontakt');
    wrap.innerHTML = (force
        ? CBT('<p class="cca-lead__intro"><b>Wysyłka rutyny</b>Podaj imię i e-mail. Zapiszemy je w naszej bazie klientów i wyślemy rutynę na ten adres.</p>')
        : CBT('<p class="cca-lead__intro"><b>Zostaw kontakt</b>Zapiszemy Twoje imię i e-mail w naszej bazie klientów. Gdy poprosisz o rutynę z czatu, wyślemy ją na ten adres.</p>'))
      + CBT('<div class="cca-lead__field"><input class="cca-lead__input" type="text" placeholder="Imię" maxlength="50" value="') + escapeHTML(preName) + '" name="firstName"></div>'
      + '<div class="cca-lead__field"><input class="cca-lead__input" type="email" placeholder="Email" maxlength="100" value="' + escapeHTML(preEmail) + '" name="email"></div>'
      + CBT('<label class="cca-lead__consent"><input type="checkbox" name="rodo"><span>Zgoda na przetwarzanie danych przez <b>TOP Cosmetics Europe</b>. Szczegóły w <a href="/policies/privacy-policy" target="_blank">polityce prywatności</a>.</span></label>')
      + '<button class="cca-lead__submit" type="button">' + escapeHTML(submitLabel) + '</button>';
    const sub = wrap.querySelector('.cca-lead__submit');
    track('cca_lead_capture_shown', { context: ctx });
    sub.addEventListener('click', async () => {
      const firstName = wrap.querySelector('[name="firstName"]').value.trim();
      const email = wrap.querySelector('[name="email"]').value.trim();
      const rodo = wrap.querySelector('[name="rodo"]').checked;
      if (!firstName || !email || !rodo) { showToast(CBT('Uzupełnij wszystkie pola')); return; }
      if (firstName.length < 2 || !LEAD_EMAIL_RE.test(email.toLowerCase())) { showToast(I18N.leadInvalid); return; }
      sub.disabled = true; sub.textContent = CBT('Zapisuję...');
      try {
        const r = await fetch(ENDPOINT_LEAD, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ sessionId: getSessionId(), firstName, email, consentRodo: true, consentAt: new Date().toISOString(), pageUrl: location.href, pageTitle: document.title, segment }) });
        if (!r.ok) {
          sub.disabled = false; sub.textContent = submitLabel;
          track('cca_lead_capture_error', { stage: 'upstream', status: r.status, context: ctx });
          showToast(r.status === 429 ? I18N.rateLimited : (r.status === 400 ? I18N.leadInvalid : I18N.leadSaveFailed));
          return;
        }
        leadCaptured = true;
        try { localStorage.setItem(LEAD_KEY, JSON.stringify({ firstName, email })); } catch(e){}
        wrap.innerHTML = CBT('<p class="cca-lead__intro"><b>Dziękujemy! ✓</b>Zapisaliśmy Twój kontakt.</p>');
        track('cca_lead_capture_submitted', {
          recipient_domain: (email.split('@')[1] || ''),
          submit_ok: r.ok,
          submit_status: r.status,
          context: ctx
        });
        if (cb) cb({ firstName, email });
      } catch(e) {
        sub.disabled = false; sub.textContent = submitLabel;
        track('cca_lead_capture_error', { stage: 'network', error: String(e && e.message || e), context: ctx });
        showToast(I18N.networkError);
      }
    });
    m.appendChild(wrap); scrollBottom();
    return wrap;
  }

  // SSE-aware sendMessage (rev 5, rev 8 — text_delta progressive bubble)
  async function sendMessage(text, extra){
    if (!text || isSending) return;
    isSending = true; setQuickReplies([]); showTyping();
    // rev 8 — reset streaming bubble for the new request
    streamingBubble = null;
    const sendBtn = ui.panel.querySelector('.cca-send'); const input = ui.panel.querySelector('.cca-input');
    if (sendBtn) sendBtn.disabled = true;
    const payload = {
      sessionId: getSessionId(),
      message: text,
      segment,
      locale: (typeof CB_LANG !== 'undefined' ? CB_LANG : 'pl'),
      page: { type: CFG.page_type, product: CFG.current_product, collection: CFG.current_collection },
      customer: window.__cca_customer ? { firstName: window.__cca_customer.firstName, email: window.__cca_customer.email, segment: window.__cca_customer.segment, tags: window.__cca_customer.tags } : null,
      history: messageHistory.slice(-10),
      extra: extra || null
    };
    const t0 = Date.now();
    let finalData = null;
    let stagesSeen = 0;
    let toolsList = [];
    let textDeltaCount = 0;
    let ttftMs = null;
    try {
      const r = await fetch(ENDPOINT_CHAT, { method: 'POST', headers: { 'Content-Type': 'application/json', 'X-CCA-Segment': segment, 'X-CCA-Version': 'v3' }, body: JSON.stringify(payload) });
      if (!r.ok) {
        hideTyping();
        track('cca_message_error', { status: r.status, duration_ms: Date.now() - t0 });
        addError(r.status === 429 ? I18N.rateLimited : I18N.networkError);
      } else {
        const ct = (r.headers.get('content-type') || '').toLowerCase();
        if (ct.indexOf('text/event-stream') >= 0 && r.body) {
          // SSE stream — parse stages incrementally
          const reader = r.body.getReader();
          const decoder = new TextDecoder();
          let buf = '';
          while (true) {
            const { value, done } = await reader.read();
            if (done) break;
            buf += decoder.decode(value, { stream: true });
            const evts = buf.split('\n\n');
            buf = evts.pop() || '';
            for (const ev of evts) {
              if (!ev.trim()) continue;
              let eventName = 'message', dataStr = '';
              const lines = ev.split('\n');
              for (const ln of lines) {
                if (ln.startsWith('event:')) eventName = ln.slice(6).trim();
                else if (ln.startsWith('data:')) dataStr = ln.slice(5).trim();
              }
              if (!dataStr) continue;
              let dat = null;
              try { dat = JSON.parse(dataStr); } catch(e) { continue; }
              if (eventName === 'stage') {
                stagesSeen++;
                if (dat.tool) toolsList.push(dat.tool);
                updateTypingLabel(labelForStage(dat));
              } else if (eventName === 'text_delta') {
                // rev 8 — progressive text rendering inside an assistant bubble
                if (ttftMs == null) ttftMs = Date.now() - t0;
                textDeltaCount++;
                // hide typing indicator the moment text starts flowing
                hideTyping();
                const bubble = ensureStreamingBubble();
                bubble.textContent += (dat.delta || '');
                scrollBottom();
              } else if (eventName === 'complete') {
                finalData = dat;
              } else if (eventName === 'error') {
                hideTyping();
                addError(dat.message || I18N.networkError);
                track('cca_message_error', { stage: 'sse_error', duration_ms: Date.now() - t0, upstream_message: dat.message });
                isSending = false;
                if (sendBtn) sendBtn.disabled = false;
                if (input) input.focus();
                return;
              }
            }
          }
          hideTyping();
          if (finalData) {
            // rev 8 — if we were streaming text into a bubble, finalize it with
            // sanitized HTML reply and skip the duplicate addBot() in renderResponse
            if (streamingBubble && streamingBubble.isConnected) {
              if (finalData.reply) {
                streamingBubble.innerHTML = sanitizeBotHTML(finalData.reply);
              }
              streamingBubble.classList.remove('cca-msg--streaming');
              delete streamingBubble.dataset.streaming;
              // signal renderResponse to skip the standalone reply bubble
              finalData.__replyConsumed = true;
            }
            streamingBubble = null;
            renderResponse(finalData);
            track('cca_message_response', {
              duration_ms: Date.now() - t0,
              response_products: (finalData.products || []).length,
              response_has_routine: !!finalData.routine,
              response_has_quiz: !!finalData.quiz,
              tool_calls: finalData.toolCalls || 0,
              escalated: !!finalData.escalated,
              intent: (extra && extra.intent) || null,
              sse_stages: stagesSeen,
              sse_tools: toolsList.join('|'),
              text_delta_count: textDeltaCount,
              ttft_ms: ttftMs
            });
            messageHistory.push({ role: 'user', content: text });
            if (finalData.reply) messageHistory.push({ role: 'assistant', content: finalData.reply });
          } else {
            addError(I18N.networkError);
            track('cca_message_error', { stage: 'sse_no_complete', duration_ms: Date.now() - t0, text_delta_count: textDeltaCount });
          }
        } else {
          // Legacy JSON fallback (in case backend reverts)
          const data = await r.json();
          hideTyping();
          renderResponse(data);
          track('cca_message_response', {
            duration_ms: Date.now() - t0,
            response_products: (data.products || []).length,
            response_has_routine: !!data.routine,
            response_has_quiz: !!data.quiz,
            tool_calls: data.toolCalls || 0,
            escalated: !!data.escalated,
            intent: (extra && extra.intent) || null
          });
          messageHistory.push({ role: 'user', content: text });
          if (data.reply) messageHistory.push({ role: 'assistant', content: data.reply });
        }
      }
    } catch(e) {
      hideTyping();
      track('cca_message_error', { stage: 'network', duration_ms: Date.now() - t0, error: String(e && e.message || e) });
      addError(I18N.networkError);
    }
    isSending = false;
    if (sendBtn) sendBtn.disabled = false;
    if (input) input.focus();
    messageCount++;
    if (messageCount === 3 && !leadCaptured && !(window.__cca_customer && window.__cca_customer.email)) {
      setTimeout(()=>addLeadCapture(false), 800);
    }
  }

  function renderResponse(data){
    if (!data) return;
    // rev 8 — if streaming bubble already received and finalized the reply, skip addBot
    if (data.reply && !data.__replyConsumed) addBot(data.reply);
    if (data.products && data.products.length) addProducts(data.products);
    if (data.routine) addRoutine(data.routine);
    if (data.quiz) addQuiz(data.quiz);
    if (data.intents_grid && data.intents_grid.length) addIntents(data.intents_grid);
    if (data.issues_grid && data.issues_grid.length) addIssues(data.issues_grid);
    if (data.cta) addCTA(data.cta);
    if (data.quick_replies) setQuickReplies(data.quick_replies);
  }

  function addCTA(cta){
    const m = ui.panel.querySelector('.cca-msgs');
    const a = document.createElement('a');
    a.className = 'cca-routine__cta-btn cca-routine__cta-btn--primary';
    a.style.cssText = 'display:inline-flex;margin:6px 0;align-self:flex-start;text-decoration:none';
    a.href = cta.url || '#'; a.target = '_blank'; a.rel = 'noopener';
    a.textContent = cta.label || CBT('Zobacz');
    a.addEventListener('click', () => track('cca_cta_click', { cta_label: cta.label, cta_url: cta.url }));
    m.appendChild(a); scrollBottom();
  }

  function openPanel(){
    if (!ui) return;
    isOpen = true;
    ui.panel.classList.add('cca-panel--open');
    ui.launcher.classList.add('cca-launcher--hidden');
    if (overlapCtl) overlapCtl.deactivate();          // R7A1: launcher schowany → rozłącz obserwatory
    try { localStorage.setItem(SEEN_KEY, '1'); } catch(e){}
    track('cca_open', { first_open: messageCount === 0, message_count: messageCount });
    if (messageCount === 0) {
      const name = (window.__cca_customer && window.__cca_customer.firstName) ? (', ' + window.__cca_customer.firstName) : '';
      addBot(I18N.welcome.replace('{name}', name));
      addIntents(DEFAULT_INTENTS);
    }
    setTimeout(()=>{ const inp = ui.panel.querySelector('.cca-input'); if (inp && window.matchMedia('(min-width:641px)').matches) inp.focus(); }, 400);
  }
  function closePanel(){ if (!ui) return; isOpen = false; ui.panel.classList.remove('cca-panel--open'); ui.launcher.classList.remove('cca-launcher--hidden'); if (overlapCtl) overlapCtl.activate(); track('cca_close', { message_count: messageCount }); }

  /* --- R7A1 (2026-08-04): unikanie kolizji launchera BEZ nasłuchu scroll ---
     Wersja poprzednia wisiała na `scroll` + requestAnimationFrame i w każdej
     klatce robiła getBoundingClientRect() na WSZYSTKICH elementach pasujących do
     listy selektorów (na kolekcji: przycisk każdego kafla). Trace CDP:
     310 ms self-time tej jednej funkcji na PDP mobile.

     Teraz: jeden IntersectionObserver, którego korzeń jest zwężony `rootMargin`em
     dokładnie do prostokąta launchera powiększonego o 8 px. Przecięcie z
     obserwowanym elementem == kolizja. Zero pomiarów layoutu z JS przy
     przewijaniu, zero rAF.

     Zakres obserwacji:
       · PDP  — GŁÓWNY formularz produktu (`.christina-atf__form` /
                `form[action*="/cart/add"]`), nie pojedyncze przyciski,
       · kolekcja — przycisków kafli NIE skanujemy w ogóle,
       · dodatkowo pływające CTA kampanijne (`.cmp-cta`, `.cmp-mystery-btn`)
         i `.shopify-payment-button`, twardy limit MAX_TARGETS.
     Referencje elementów są cache'owane; po AJAX-owym przerenderowaniu
     odświeżamy je tylko w obrębie kontenera pilnowanego przez MutationObserver.

     Bramka wydajnościowa: gdy launcher jest ukryty (T59-ENTRY — wejściem do
     czatu jest `[data-cca-open]` w nagłówku, a `.cca-launcher` ma
     `display:none!important` w `christina-layers.css`), NIE zakładamy żadnych
     obserwatorów ani nasłuchów roboczych. */
  let overlapCtl = null;

  function setupOverlapAvoidance(launcher){
    if (!launcher || !window.IntersectionObserver) return;

    const mql = window.matchMedia('(max-width:640px)');
    const MAX_TARGETS = 6;
    const SEL_PDP = '.christina-atf__form, form[action*="/cart/add"]';
    const SEL_FLOAT = '.cmp-cta, .cmp-mystery-btn, .shopify-payment-button';
    const isProduct = (CFG.page_type === 'product') || !!document.querySelector('.christina-atf__form');

    let io = null, mo = null, targets = [], overlapping = 0, resizeT = null;

    function idleRun(fn){
      const r = window.requestIdleCallback;
      if (r) { try { r(fn, { timeout: 1000 }); return; } catch(e){} }
      setTimeout(fn, 200);
    }
    function launcherVisible(){
      return !!(launcher.offsetWidth || launcher.offsetHeight || launcher.getClientRects().length);
    }
    function apply(){
      launcher.classList.toggle('cca-launcher--avoiding', overlapping > 0 && mql.matches && !isOpen);
    }
    function collect(root){
      const scope = root || document;
      const out = [];
      if (isProduct) { const f = scope.querySelector(SEL_PDP); if (f) out.push(f); }
      const fl = scope.querySelectorAll(SEL_FLOAT);
      for (let i = 0; i < fl.length && out.length < MAX_TARGETS; i++) if (fl[i] !== launcher) out.push(fl[i]);
      return out;
    }
    function dropIO(){
      if (io) { try { io.disconnect(); } catch(e){} io = null; }
      overlapping = 0;
    }
    function buildIO(){
      dropIO();
      if (!targets.length) return false;
      const lr = launcher.getBoundingClientRect();          // jeden pomiar na (re)budowę, nie na klatkę
      if (!lr.width || !lr.height) return false;
      const vw = window.innerWidth, vh = window.innerHeight;
      const rm = [
        -Math.max(0, lr.top - 8),                            // top
        -Math.max(0, vw - (lr.right + 8)),                   // right
        -Math.max(0, vh - (lr.bottom + 8)),                  // bottom
        -Math.max(0, lr.left - 8)                            // left
      ].map(v => Math.round(v) + 'px').join(' ');
      io = new IntersectionObserver(function(entries){
        for (let i = 0; i < entries.length; i++) {
          const e = entries[i], was = e.target.__ccaOv === true;
          e.target.__ccaOv = e.isIntersecting;
          if (e.isIntersecting && !was) overlapping++;
          else if (!e.isIntersecting && was) overlapping--;
        }
        if (overlapping < 0) overlapping = 0;
        apply();
      }, { root: null, rootMargin: rm, threshold: 0 });
      for (let i = 0; i < targets.length; i++) { targets[i].__ccaOv = false; io.observe(targets[i]); }
      return true;
    }
    function watchContainer(){
      if (mo || !isProduct || !window.MutationObserver) return;   // kolekcja: nic nie obserwujemy
      const host = document.querySelector('.christina-atf') ||
                   (targets[0] && targets[0].parentElement) ||
                   document.getElementById('MainContent');
      if (!host) return;
      let queued = false;
      mo = new MutationObserver(function(){
        if (queued) return;
        queued = true;
        idleRun(function(){
          queued = false;
          const f = host.querySelector(SEL_PDP);               // tylko zmieniony kontener
          if (f && targets[0] !== f) { targets[0] = f; buildIO(); }
        });
      });
      mo.observe(host, { childList: true, subtree: true });
    }
    function deactivate(){
      dropIO();
      if (mo) { try { mo.disconnect(); } catch(e){} mo = null; }
      targets = [];
      launcher.classList.remove('cca-launcher--avoiding');
    }
    function activate(){
      if (!mql.matches || isOpen || !launcherVisible()) { deactivate(); return; }
      targets = collect();
      if (!targets.length) { deactivate(); return; }
      buildIO();
      watchContainer();
    }

    overlapCtl = { activate: activate, deactivate: deactivate };

    if (mql.addEventListener) mql.addEventListener('change', activate);
    else if (mql.addListener) mql.addListener(activate);
    window.addEventListener('resize', function(){
      if (resizeT) clearTimeout(resizeT);
      resizeT = setTimeout(function(){ resizeT = null; activate(); }, 250);   // rootMargin zależy od viewportu
    }, { passive: true });
    window.addEventListener('pagehide', deactivate, { once: true });

    idleRun(activate);
  }

  function init(){
    segment = getSegment();
    ui = buildUI();
    ui.panel.querySelectorAll('.cca-segment__opt').forEach(b => {
      if (b.dataset.seg === segment) b.classList.add('cca-segment__opt--active');
      b.addEventListener('click', () => {
        ui.panel.querySelectorAll('.cca-segment__opt').forEach(x => x.classList.toggle('cca-segment__opt--active', x === b));
        setSegment(b.dataset.seg);
        track('cca_segment_changed', { new_segment: b.dataset.seg });
        document.dispatchEvent(new CustomEvent('cca:segment-changed', { detail: { segment: b.dataset.seg } }));
      });
    });
    ui.launcher.addEventListener('click', openPanel);
    ui.panel.querySelector('.cca-close').addEventListener('click', closePanel);
    const form = ui.panel.querySelector('.cca-input-area');
    form.addEventListener('submit', e => {
      e.preventDefault();
      const input = ui.panel.querySelector('.cca-input');
      const t = (input.value||'').trim();
      input.value = ''; input.style.height = 'auto';
      if (t) { addUser(t); sendMessage(t); }
    });
    const input = ui.panel.querySelector('.cca-input');
    input.addEventListener('keydown', e => {
      if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); const t = (input.value||'').trim(); input.value = ''; input.style.height = 'auto'; if (t) { addUser(t); sendMessage(t); } }
    });
    input.addEventListener('input', () => { input.style.height = 'auto'; input.style.height = Math.min(input.scrollHeight, 90) + 'px'; });
    document.addEventListener('keydown', e => { if (e.key === 'Escape' && isOpen) closePanel(); });
    setupOverlapAvoidance(ui.launcher);
    track('cca_init', { advisor_version: 'v2.9' });
    window.ChristinaAdvisor = {
      open: openPanel, close: closePanel,
      send: t => { if (!isOpen) openPanel(); setTimeout(()=>{ addUser(t); sendMessage(t); }, 250); },
      getSegment: () => segment,
      setSegment: s => { setSegment(s); ui.panel.querySelectorAll('.cca-segment__opt').forEach(b => b.classList.toggle('cca-segment__opt--active', b.dataset.seg === s)); },
      /* R7A1: awaryjne wyłączenie Advisora — rozłącza wszystkie obserwatory. */
      destroy: () => { if (overlapCtl) overlapCtl.deactivate(); }
    };
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
